import { FrVrfAlertBar } from "@vrf/fr-vrf-web-components-react";
import { useGlobalState } from "@vrf/fr-vrf-core-react";

const COMMON_FIELD_ID = "_common_";

export const AlertBarForMultipleErrorMessages = () => {
  const [globalState] = useGlobalState();

  const messageList = globalState.errorMessages
    .filter((message) => !(message?.fieldPaths[0] == COMMON_FIELD_ID))
    .map((message) => ({
      id: message.id,
      message: message.message,
    }));

  return (
    <>
      {messageList.length > 0 && (
        <FrVrfAlertBar messageList={messageList}></FrVrfAlertBar>
      )}
    </>
  );
};
